module.exports = __webpack_public_path__ + "media/post-listing-block-4-overlay-wide.6bcba3bf.png";